import { render } from "./ConsentFrom.vue?vue&type=template&id=7559bdf1&scoped=true"
import script from "./ConsentFrom.vue?vue&type=script&lang=js"
export * from "./ConsentFrom.vue?vue&type=script&lang=js"

import "./ConsentFrom.vue?vue&type=style&index=0&id=7559bdf1&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7559bdf1"]])

export default __exports__